module.exports = require("mobx-vue");